<template>
  <div class="oldNew">
    <div class="oldContainer">
      <div class="content">
        <div class="inContent">
          <div class="titleImg">
            <img src="../assets/images/oldkuntong.png" alt="" />
          </div>
          <div class="word">
            昆通卡号以“2153…”开头的老昆通卡、老市民卡、新市民卡。
          </div>
          <div class="imgContent">
            <img src="../assets/images/imageOldk.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="inContent">
          <div class="titleImg">
            <img src="../assets/images/newkuntong.png" alt="" />
          </div>
          <div class="word">
            昆通卡号以“31048315…”开头的新昆通卡、新市民卡。
          </div>
          <div class="imgContent">
            <img src="../assets/images/imageNewk.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
export default {
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.oldContainer {
  height: 100vh;
  background-color: #eef4f6;
  padding: 2.25rem 2rem;
  .content {
    border-radius: 1rem;
    background: #fff;
    padding: 2.875rem 2rem;
    .titleImg {
      img {
        width: 10.375rem;
        height: 3.25rem;
      }
    }
    .word {
      margin-top: 1.625rem;
      font-size: 1.875rem;
      line-height: 3.75rem;
      color: #555555;
    }
    .imgContent {
      margin-top: 1.5rem;
      img {
        width: 38.875rem;
      }
    }
  }
}
</style>